import { useLocation, useParams } from "react-router-dom";
import { WithAuthInfoProps, withRequiredAuthInfo } from "@propelauth/react";
import { Project } from "@models/project";
import { getProject, searchBidders } from "../../api/ProjectLoader";
import { useEffect, useState } from "react";
// import { InviteBidderByEmail } from '../directory/InviteByEmail'
import SearchBidderView from "../developer/InviteByCompanySearch";
import BidSummary from "../bid/BiddingSummaryView";
import BaseLoadingSpinner from "../ui/baseLoadingSpinner";

// Restricted to Developers ONLY
// This view is for developers to find bidders for their projects
// Developers can
//  1) invite using an email
// 2) or they can search companies by criteria
//

interface BidderSummaryItem {
    name: string;
    _id: string;
}

interface ListBidders {
    bidders: BidderSummaryItem[];
}

function BidderSearch() {}

// -------
// this is really a directory ... can we make a generic directory view
function BidderSummaryItem({ item }: { item: BidderSummaryItem }) {
    return (
        <tr>
            <td>{item.name}</td>
            <td></td>
            <td></td>
            <td>
                <button>Invite</button>
            </td>
        </tr>
    );
}

function BidderList({ bidders }: ListBidders) {
    return (
        <table>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>prop1</th>
                    <th>prop2</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {bidders.map((bidder_item) => (
                    <BidderSummaryItem
                        key={bidder_item._id}
                        item={bidder_item}
                    />
                ))}
            </tbody>
        </table>
    );
}

// here
function FindBidderView(props: WithAuthInfoProps) {
    const location = useLocation();
    const [project, setProject] = useState<Project | null>(null);
    const { project_id } = useParams<string>();
    // const { project }: { project: Project } = location.state

    useEffect(() => {
        if (project_id) {
            getProject(project_id, props.accessToken).then((data) => {
                console.log(data);
                setProject(data);
            });
        }
    }, [project_id]);

    const [bidderList, SetBidderList] = useState<any>(null);
    const [nameSearch, SetNameSearch] = useState<string | null>(null);
    // const

    const onInvite = (email: string) => {};

    // useEffect(() => {
    //     searchBidders({} as SearchCriteria, props.accessToken)
    //         .then((data) => {
    //             console.log(data)
    //             SetBidderList(data)
    //
    //         }
    //         );
    // }, []);

    if (!project) {
        return <div><BaseLoadingSpinner/></div>;
    }
    return (
        <div className="content">
            <BidSummary  />
        </div>
    );
}

export default withRequiredAuthInfo(FindBidderView);
